import React from 'react';
import AppBar from '@mui/material/AppBar';
import Avatar from '@mui/material/Avatar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';

const Root = styled(AppBar)(() => ({
  width: '100%',
  zIndex: 2
}));

const HomeButton = styled(IconButton)(() => ({
  marginLeft: -12,
  marginRight: 20,
}));

const HeaderTitle = styled(Typography)(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.up('sm')]: {
    display: 'block',
  },
}));

export default function MainAppBar() {
  return (
    <Root position="static">
      <Toolbar>
        <HomeButton href="." color="inherit" aria-label="Home">
          <Avatar alt={"Schemmerhofen Formulare"} src="./favicon.png" />
        </HomeButton>
        <HeaderTitle variant="h6" color="inherit" noWrap>Schemmerhofen Veranstaltungen</HeaderTitle>
      </Toolbar>
    </Root>
  );
}
